import FirebaseService from "../../../services/firebase/firebase.service";
import { DashboardEmptyStateCopy } from "../dashboard.types";
import newDashEmptyGraphic from "../../../assets/images/new-dash-empty.png";
import { useDashboardSurveyList } from "./useDashboardSurveyList";

const DashboardSurveyListEmptyComponent = () => {
  const { filteredResults } = useDashboardSurveyList();

  const allEmpty = () => {
    const { emptyStateTitle, emptyStateSubtitle, learnMoreHelperText, learnMoreLink } = FirebaseService.getRemoteConfigJSON<DashboardEmptyStateCopy>('DASHBOARD_EMPTY_STATE_COPY');
    return (
      <>
        <div className="flex flex-col items-center mt-10 mb-6">
          <div className="text-3xl font-light">
            {emptyStateTitle}
          </div>
          <div>
            {emptyStateSubtitle}
          </div>
        </div>
        <div className="text-xs text-gray-401">
          <a
            href={learnMoreLink}
            className="text-gray-401 underline mr-1"
          >
            Learn more
          </a>
          {learnMoreHelperText}
        </div>
      </>
    );
  };

  const emptyTitle = () => {
    return (
      <>
        <div className="text-3xl font-light mt-10">
          No surveys found.
        </div>
        <div>
          Try changing your search criteria.
        </div>
      </>
    );
  };

  return (
    <div className="flex flex-col h-full items-center justify-center bg-white border border-gray-light-10 rounded-xl py-4 sm:py-32">
      <img
        src={newDashEmptyGraphic}
        className="w-40 h-20"
      />
      {filteredResults ? (emptyTitle()) : allEmpty()}
    </div>
  );
};

export default DashboardSurveyListEmptyComponent;
